export enum MimeType {
  OCTET_STREAM = 'octet/stream',
  APPLICATION_PDF = 'application/pdf'
}
